export abstract class VideoPlayerFactoryBase {
    protected setupFrame(frameId: string): JQuery {
        const videoFrameElement = $(`#${frameId}`);
        const src = videoFrameElement.data("src") as string;
        videoFrameElement.attr("src", src);

        return videoFrameElement;
    }
}
